module.exports = __webpack_public_path__ + "img/linkedin.ff06b181.png";